
import { useEffect, useState } from "react";
import { BeneficiaryDetailsPopUpTableDataAPI, PlantingMaterialPackagingDeleteAPI } from "../../../../Helper/Redux/AdminDashboardSlice/BeneficiaryDetailsSlice";
import AddMaterialPackagingPopup from "./AddMaterialPackagingPopup/AddMaterialPackagingPopup";
import { useAuthState } from "../../../../Helper/Context/context";
import { useDispatch, useSelector } from "react-redux";
import DeletePopUP from "../../../CommonPopUp/DeletePopUp";
import { Loading } from "../../../../Helper/LogoLoader/LogoLoader";



const PlantingMaterialPackaging = (props) => {

    const { handleIsPost, M_BeneficiaryDetailsID, BeneficiaryPackaging, DataIsPost, setDataIsPost } = props

    const userDetails = useAuthState();
    const { UserID, token } = userDetails
    const dispatch = useDispatch()

    const [AddMaterialPopup, setAddMaterialPopup] = useState(false)

    const [ShowDeletePopup, setShowDeletePopup] = useState(false)
    const [ShowDeletePopupData, setShowDeletePopupData] = useState({
        data: ''
    })


    const handleAddMaterial = () => {
        setAddMaterialPopup(!AddMaterialPopup)
    }

    const handleShowDelete = (data) => {

        setShowDeletePopup(!ShowDeletePopup)
        { data && setShowDeletePopupData(data) }
    }
    const handleDataIsPost = () => {
        setDataIsPost(!DataIsPost)
    }

    const handleDeleteData = () => {
        const data = {
            M_BeneficiaryDetails_PlanMaterial_PackagingID: ShowDeletePopupData?.m_BeneficiaryDetails_PlanMaterial_PackagingID,
            M_TableUserMasterID: UserID,
            Flag: 'Delete',
            token: token,
            handleDataIsPost
        }
        dispatch(PlantingMaterialPackagingDeleteAPI({ data }))
    }

    const { isDeleteLoading } = useSelector(state => state.PlantingMaterialPackagingDeleteData)

    return (
        <>
            {isDeleteLoading && <Loading />}
            <div className="col-xl-6 col-lg-3 pt-2 mt-3 mt-lg-0 pt-lg-2 my-4">
                <span className="fw-bold ">Planting Material Packaging</span>
                <div className="pt-2 text-start">

                    <span className=" add_button px-3 py-1"
                        onClick={() => handleAddMaterial()} >
                        <i class="fa-solid fa-plus"></i>  Add
                    </span>
                </div>


            </div>

            <div className="col-12 pt-2 mt-3 mt-lg-0 pt-lg-2 my-2">

                <div className="table-responsive p-0" >
                    <table className="table table-bordered">
                        <thead>
                            <tr className=" text-white">
                                <th className="text-center">Sr. No.</th>
                                <th className="text-center">Packaging Name </th>
                                <th className="text-center">Packaging Value </th>
                                <th className="text-center">Action</th>


                            </tr>
                        </thead>
                        <tbody>
                            {
                                BeneficiaryPackaging && BeneficiaryPackaging.length > 0 ? BeneficiaryPackaging.map((i, j) => {
                                    return (
                                        <tr>
                                            <td align="center">{j + 1}</td>
                                            <td>{i.plantMaterial_PackagingName ? i.plantMaterial_PackagingName : '-'}</td>
                                            <td>{i.plantMaterial_Value ? i.plantMaterial_Value : '-'}</td>

                                            <td align="center">

                                                <i className="fa fa-trash mx-2 text-danger v_icon_style"
                                                    onClick={() => handleShowDelete(i)}
                                                    title="Do you want to delete this record?"></i>
                                            </td>

                                        </tr>
                                    )
                                })
                                    :
                                    <>No data found</>
                            }

                        </tbody>
                    </table>

                </div>

            </div>


            {
                AddMaterialPopup &&
                <AddMaterialPackagingPopup
                    handleAddMaterial={handleAddMaterial}
                    Title='Planting Material Packaging'
                    M_BeneficiaryDetailsID={M_BeneficiaryDetailsID}
                    handleDataIsPost={handleDataIsPost}

                // Message='Are you sure! Do you want to Update ?'
                // ModalData={ModalData}

                />
            }
            {
                ShowDeletePopup ?
                    <DeletePopUP
                        handleShowDelete={handleShowDelete}
                        ShowDeletePopupData={ShowDeletePopupData}
                        handleDeleteData={handleDeleteData}

                    /> : <></>
            }


        </>
    );
}

export default PlantingMaterialPackaging;